import { ReactNode } from 'react';
import { errorId } from './errorId';
import './FormField.css';

type Props = {
  htmlFor: string;
  label: string;
  required: boolean;
  error?: string;
  children: ReactNode;
};

export const FieldErrorMessage = ({ id, message }: { id: string; message: string }) => (
  <div className="field-error" id={id}>
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.6" />
      <path d="M10 6v4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="10" cy="13.6" r="1" fill="currentColor" />
    </svg>
    <span>{message}</span>
  </div>
);

export default function FormField({ htmlFor, label, required, error, children }: Props) {
  return (
    <div className="field">
      <label htmlFor={htmlFor} className="field-label-row">
        <span className="field-label">{label}</span>
        {!required && <>{' '}<span className="field-optional">Optional</span></>}
      </label>
      {children}
      {error !== undefined && <FieldErrorMessage id={errorId(htmlFor)} message={error} />}
    </div>
  );
}
